"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPersonalityMarkdown = exports.getDetailMarkdown = void 0;
const dantalion_core_1 = require("@kurone-kito/dantalion-core");
const article_1 = __importDefault(require("./article"));
const list_1 = require("./list");
const template_1 = require("./template");
/**
 * Get the personality information.
 * @param accessors The accessors instance for resources.
 * @param genius The types of personality.
 * @returns The string that the personality information
 * as the Markdown format.
 *
 * If you specified the `undefined` value as an argument or omitted it,
 * it would be a list of the available types.
 */
const getDetailMarkdown = (accessors, genius) => {
    const result = genius && dantalion_core_1.getDetail(genius);
    const desc = accessors.getDescription(genius);
    return genius && result
        ? article_1.default({
            body: template_1.createDetailsTemplate(genius, result, accessors),
            head: `Dantalion: ${desc.detail}`,
        })
        : article_1.default({
            body: list_1.list(...dantalion_core_1.types.genius),
            head: `Dantalion: ${desc.details}`,
        });
};
exports.getDetailMarkdown = getDetailMarkdown;
/**
 * Get the personality information corresponding to the specified birthday.
 * @param accessors The accessors instance for resources.
 * @param birth Specify a birthday within the range from February 1, 1873,
 * to December 31, 2050.
 *
 * Ignore the _time_ information.
 * @returns The string that the personality information
 * as the Markdown format.
 *
 * If the date is over the range, it will be error message.
 */
const getPersonalityMarkdown = (accessors, birth) => {
    const result = dantalion_core_1.getPersonality(birth);
    const desc = accessors.getDescription(new Date(birth).toDateString());
    return result
        ? article_1.default({
            body: template_1.createPersonalityTemplate(result, accessors),
            head: `Dantalion: ${desc.personality}`,
        })
        : article_1.default({ head: `Dantalion: ${desc.invalid}` });
};
exports.getPersonalityMarkdown = getPersonalityMarkdown;
//# sourceMappingURL=index.js.map